import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class SearchFieldController extends Controller {
  static targets = ['input', 'clear']

  input () {
    this.clearTarget.classList.toggle('hidden', !this.inputTarget.value)
  }

  clear () {
    this.inputTarget.value = ''
    this.clearTarget.classList.add('hidden')
    this.inputTarget.focus()
  }
}

stimulus.register('search-field', SearchFieldController)
